var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.propAuth == _vm.AUTHORIZED)?_c('b-button',{class:_vm.buttonClass,attrs:{"variant":"light"},on:{"click":function($event){return _vm.clickLinkBtn()}}},[_c('b-icon',{staticClass:"mr-2",attrs:{"icon":_vm.propBtnIcon,"variant":_vm.propBtnIconVariant}}),_vm._v(_vm._s(_vm.propBtnText)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }